import { createAction } from 'redux-actions';

import { createAlertAction } from 'store/alerts';

import {
  UPDATE_MEDICAL_HISTORY,
  RESET_MEDICAL_HISTORY,
  UPDATE_MEDICATIONS,
  UPDATE_MEDICATION,
  DELETE_MEDICATION,
  RESET_MEDICATIONS,
  FETCH_MEDICAL_HISTORY,
  FETCH_COLLECT_MEDICAL_HISTORY,
  SAVE_MEDICAL_HISTORY,
  UPLOAD_MEDIA_DATA,
  FETCH_SEARCHABLE_MEDIA,
  DELETE_SEARCHABLE_MEDIA,
  FETCH_DRUGS,
  SAVE_DRUG,
  CREATE_MEDICATION,
  SAVE_MEDICATION,
  REMOVE_MEDICATION,
} from './types';

export const updateMedicalHistory = createAction(UPDATE_MEDICAL_HISTORY);
export const resetMedicalHistory = createAction(RESET_MEDICAL_HISTORY);
export const updateMedications = createAction(UPDATE_MEDICATIONS);
export const updateMedication = createAction(UPDATE_MEDICATION);
export const deleteMedication = createAction(DELETE_MEDICATION);
export const resetMedications = createAction(RESET_MEDICATIONS);

export const fetchMedicalHistory = createAlertAction(FETCH_MEDICAL_HISTORY);
export const fetchCollectMedicalHistory = createAlertAction(FETCH_COLLECT_MEDICAL_HISTORY);
export const saveMedicalHistory = createAlertAction(SAVE_MEDICAL_HISTORY);
export const uploadMediaData = createAlertAction(UPLOAD_MEDIA_DATA);
export const fetchSearchableMedia = createAlertAction(FETCH_SEARCHABLE_MEDIA);
export const deleteSearchableMedia = createAlertAction(DELETE_SEARCHABLE_MEDIA);
export const fetchDrugs = createAlertAction(FETCH_DRUGS);
export const saveDrug = createAlertAction(SAVE_DRUG);
export const createMedication = createAlertAction(CREATE_MEDICATION);
export const saveMedication = createAlertAction(SAVE_MEDICATION);
export const removeMedication = createAlertAction(REMOVE_MEDICATION);
